import ApplicationEntryPage from 'pages/ApplicationEntryPage';
import ApplicationReviewPage from 'pages/ApplicationReviewPage';
import AppStatusPage from 'pages/AppStatusPage';
import Button from '@material-ui/core/Button';
import FindCustomerPage from 'pages/FindCustomerPage';
import Modal from '@material-ui/core/Modal';
import NotFoundPage from 'pages/NotFoundPage';
import SalespersonRequiredPage from 'pages/SalespersonRequiredPage';
import Paper from '@material-ui/core/Paper';
import TermsAndConditionsPage from 'pages/TermsAndConditionsPage';
import ThankYouPage from 'pages/ThankYouPage';
import React, { useEffect } from 'react';
import Snackbar from '@material-ui/core/Snackbar/Snackbar';
import Typography from '@material-ui/core/Typography';
import WelcomePage from 'pages/WelcomePage';
import { PropTypes } from 'prop-types';
import { Routes, Route } from 'react-router-dom';
import { withStyles } from '@material-ui/core/styles';
import withRouter from 'shared/utils/WithRouter';

export const styles = {
	// tweak the base styles
	'@global': {
		body: {
			margin: 0,
		},
	},
	modal: {
		position: 'fixed',
		width: '100%',
		maxWidth: '400px',
		height: '100%',
		maxHeight: '250px',
		top: '20%',
		left: '50%',
		transform: 'translateX(-50%)',
		padding: '20px',
		'@media only screen and (max-width: 420px) and (orientation: portrait)': {
			maxWidth: '275px',
		},
	},
	modalButtons: {
		position: 'absolute',
		bottom: '20px',
		right: '20px',
	},
};

function App(props) {
	const {
		classes,
		closeCancelConfirmModal,
		closeExitConfirmModal,
		dismissNotification,
		isCancelConfirmModalOpen,
		isExitConfirmModalOpen,
		notification,
		isSnackbarOpen,
		settings,
		openSnackbar,
	} = props;
	const { message = null, autoHideDuration = null } = notification;

	useEffect(
		() => {
			if (message && !isSnackbarOpen) {
				openSnackbar();
			}
		},
		[message, isSnackbarOpen],
	);

	return (
		<div>
			<Routes>
				<Route path="/" element={<WelcomePage />} />
				{/* on initial load the url is set to where the credit app was served from */}
				<Route path="/now" element={<WelcomePage />} />
				<Route path="/apply/now" element={<WelcomePage />} />
				<Route path="/:lang/apply/now" element={<WelcomePage />} />
				<Route path="/now/:custId" element={<WelcomePage />} />
				<Route path="/apply/now/:custId" element={<WelcomePage />} />
				<Route path="/:lang/apply/now/:custId" element={<WelcomePage />} />
				<Route path="/FindCustomer" element={<FindCustomerPage />} />
				<Route path="/ApplicationEntry" element={<ApplicationEntryPage />} />
				<Route path="/ApplicationReview" element={<ApplicationReviewPage />} />
				<Route path="/TermsAndConditions" element={<TermsAndConditionsPage />} />
				<Route path="/ThankYou" element={<ThankYouPage />} />
				<Route path="/AppStatus" element={<AppStatusPage />} />
				<Route path="/SalespersonRequired" element={<SalespersonRequiredPage />} />
				<Route element={<NotFoundPage />} />
			</Routes>
			<Snackbar
				anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
				open={isSnackbarOpen}
				onClose={dismissNotification}
				ContentProps={{
					'aria-describedby': 'message-id',
				}}
				autoHideDuration={autoHideDuration}
				message={<span id="message-id">{message}</span>}
			/>
			<Modal open={isCancelConfirmModalOpen} onClose={closeCancelConfirmModal}>
				<Paper className={classes.modal}>
					<Typography type="headline" gutterBottom>
						{settings.fieldAndFooterSettings.ModalSettings.AppCancelModalTitle !== undefined
							? settings.fieldAndFooterSettings.ModalSettings.AppCancelModalTitle
							: 'Are You sure?'}
					</Typography>
					<Typography type="subheading">
						{settings.fieldAndFooterSettings.ModalSettings.AppCancelModalText !== undefined
							? settings.fieldAndFooterSettings.ModalSettings.AppCancelModalText
							: 'Are you sure you want to cancel the application? Any information you entered will be lost.'}
					</Typography>
					<div className={classes.modalButtons}>
						<Button
							onClick={() => {
								closeCancelConfirmModal();
								props.router.navigate('/now');
							}}
						>
							Yes
						</Button>
						<Button onClick={closeCancelConfirmModal}>No</Button>
					</div>
				</Paper>
			</Modal>
			<Modal open={isExitConfirmModalOpen} onClose={closeExitConfirmModal}>
				<Paper className={classes.modal}>
					<Typography type="headline" gutterBottom>
						{settings.fieldAndFooterSettings.ModalSettings.ExitModalTitle !== undefined
							? settings.fieldAndFooterSettings.ModalSettings.ExitModalTitle
							: 'Are you sure?'}
					</Typography>
					<Typography type="subheading">
						{settings.fieldAndFooterSettings.ModalSettings.ExitModalText !== undefined
							? settings.fieldAndFooterSettings.ModalSettings.ExitModalText
							: 'Are you sure you want to exit the application?'}
					</Typography>
					<div className={classes.modalButtons}>
						<Button
							onClick={() => {
								closeExitConfirmModal();
								props.router.navigate('/now');
							}}
						>
							Yes
						</Button>
						<Button onClick={closeExitConfirmModal}>No</Button>
					</div>
				</Paper>
			</Modal>
		</div>
	);
}

App.propTypes = {
	classes: PropTypes.shape({}).isRequired,
	settings: PropTypes.shape({
		fieldAndFooterSettings: PropTypes.shape({
			ModalSettings: PropTypes.shape({
				AppCancelModalTitle: PropTypes.string,
				AppCancelModalText: PropTypes.string,
				ExitModalTitle: PropTypes.string,
				ExitModalText: PropTypes.string,
			}),
		}),
	}),
	closeCancelConfirmModal: PropTypes.func.isRequired,
	closeExitConfirmModal: PropTypes.func.isRequired,
	dismissNotification: PropTypes.func.isRequired,
	isCancelConfirmModalOpen: PropTypes.bool.isRequired,
	isExitConfirmModalOpen: PropTypes.bool.isRequired,
	notification: PropTypes.shape({
		message: PropTypes.string,
		autoHideDuration: PropTypes.number,
	}),
	openSnackbar: PropTypes.func.isRequired,
	isSnackbarOpen: PropTypes.bool.isRequired,
};

App.defaultProps = {
	notification: {},
	settings: {
		fieldAndFooterSettings: {
			ModalSettings: {
				AppCancelModalTitle: 'Are You Sure?',
				AppCancelModalText:
					'Are you sure you want to cancel the application? Any information you entered will be lost.',
				ExitModalTitle: 'Are You Sure?',
				ExitModalText: 'Are you sure you want to exit the application?',
			},
		},
	},
};

export default withRouter(withStyles(styles, { name: 'App' })(App));
